export const MAX_STATEMENT_FILES = 10;
export const MAX_STATEMENT_FILE_SIZE_BYTES = 10 * 1024 * 1024;

const SUPPORTED_EXTENSIONS = new Set(['csv', 'pdf']);

/**
 * Validates a statement batch before it is sent to the API.
 *
 * @param {File[]} files - Statement files selected by the user.
 * @returns {string|null} A translated-message key, or null when valid.
 */
export const validateStatementFiles = (files) => {
  if (!files.length) {
    return 'cc_statements.statement_imports.errors.missing_files';
  }
  if (files.length > MAX_STATEMENT_FILES) {
    return 'cc_statements.statement_imports.errors.too_many_files';
  }
  if (files.some((file) => file.size > MAX_STATEMENT_FILE_SIZE_BYTES)) {
    return 'cc_statements.statement_imports.errors.file_too_large';
  }

  const hasUnsupportedFile = files.some((file) => {
    const extension = file.name.split('.').pop()?.toLowerCase();
    return !extension || !SUPPORTED_EXTENSIONS.has(extension);
  });
  return hasUnsupportedFile ? 'cc_statements.statement_imports.errors.unsupported_file' : null;
};
